<template>
    <div>
        <div class="modal-container has-text-centered">
            <div class="is-size-5 top5 left10">
               
                <div class="delete is-large is-pulled-right right10" @click="doClose" style="z-index: 5"></div>
            </div>

            <div class="modal-body top20">
               <img class="middle egImage" id="theImg" :src="img" style="max-width: calc(100vw - 40px)"/>
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
var influencers = require('@/assets/img/EGinfluencer.png')
var print = require('@/assets/img/EGprint3.png')
var infomercial = require('@/assets/img/EGinfomercial6.png')
var billboard = require('@/assets/img/EGbillboard5.png')
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
export default {
  props: { message: String },
  data: function() {
    return {
      img: ''
    };
  },
  mounted: function() {
     if(this.$root.modalPropsObj.img == 'EGinfluencer.png'){
        this.img = influencers
        document.getElementById('theImg').style['max-height'] = 'calc(100vh - 80px)'
     } else if(this.$root.modalPropsObj.img == 'EGprint.png'){
        this.img = print
        document.getElementById('theImg').style['max-height'] = 'calc(100vh - 80px)'
     } else if(this.$root.modalPropsObj.img == 'EGinfomercial.png'){
        this.img = infomercial
     } else if(this.$root.modalPropsObj.img == 'EGbillboard.png'){
        this.img = billboard
     }
  },
  methods: {
    doClose: function() {
      this.$emit("close");
    },
  }
      
  
};
</script>

<style scoped>
.modal-container {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  border-radius: 15px;
  overflow: hidden;
  background: #000046;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #044770, #152229 );  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #044770, #152229); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}

.modal-body {
    padding: 0 !important
}

.middle {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -48%);
  -ms-transform: translate(-50%, -48%);
  transform: translate(-50%, -48%);
}
</style>



// WEBPACK FOOTER //
// src/components/LightBox.vue